/* eslint-disable import/prefer-default-export */
import React from 'react';
import Icon from '../../../../components/Icon';
import { ICONS } from '../../../../components/Icon/constants';
import { MAIN_ICON_COLORS } from '../../Icon';

export const ManageAddressesPaperIcon = () => (
  <div
    className="rounded-max bg-settings-icon me-3"
    style={{ height: '2.3rem', width: '2.3rem', paddingTop: '4px' }}>
    <div className="w-100" style={{ height: '16px', width: '16px' }}>
      <Icon icon={ICONS.PAPER} color={MAIN_ICON_COLORS.INFO} />
    </div>
  </div>
);
